<template>
  <div class="cardBox_">
    <p class="title">Rules and Guidelines</p>
    <div class="rules-container">
      <div>
        <p class="section">
          <span class="strong">1. Performance Bonus for Orders:</span>
          For existing stations, tiered rewards are provided based on the growth
          in retail volume：
        </p>
        <table>
          <thead>
            <tr>
              <th>Retail increase（Month）</th>
              <th>Rewards (Points)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in rewardTable" :key="index">
              <td>{{ item.range }}</td>
              <td>{{ item.points }}</td>
            </tr>
          </tbody>
        </table>
        <div class="examples">
          <p>Example：</p>
          <ul>
            <li>
              If Station A collects 100 retail orders in December and 160 retail
              orders in January, it will receive a reward of 1,000 points.
            </li>
            <li>
              If Station B collects 100 retail orders in December and 560 retail
              orders in January, it will receive a reward of 6,000 points.
            </li>
            <li>
              If Station C collects 100 retail orders in December and 159 retail
              orders in January, it will receive a reward of 0 points.
            </li>
          </ul>
        </div>
      </div>
      <p class="section">
        <span class="strong">2.Eligible Participants:</span>
        J&THOME users registered before {{ firstDayOfMonth }}.
      </p>
      <p class="section">
        <span class="strong">3.Implementation Period:</span>

        {{ firstDayOfMonth }} to {{ lastDayOfMonth }}
      </p>
      <p class="section">
        <span class="strong">4.Incentive Distribution:</span>
        Incentives will be issued as points in the J&THOME Mall. Points can be
        used to exchange materials within the mall.
      </p>
      <p class="section">
        <span class="strong">5.Risk Control:</span>
        Any detected fraudulent activity will result in the cancellation of all
        rewards for the station.
      </p>
    </div>
    <div class="btn">
      <van-button class="btnBox" round :plain="true" @click="confirm()">
        {{ lang('确定') }}
      </van-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import lang from '@/langs'
import { ref } from 'vue'
import dayjs from 'dayjs'
const rewardTable = [
  { range: '60 ≤ X ≤ 150', points: '1000' },
  { range: '150 < X ≤ 300', points: '2500' },
  { range: '300 < X ≤ 450', points: '4500' },
  { range: 'X > 450', points: '6000' }
]
const emits = defineEmits(['confirm'])
const firstDayOfMonth = ref(dayjs().startOf('month').format('YYYY-MM-DD'))
const confirm = () => {
  emits('confirm')
}
// 本月最后一天
const lastDayOfMonth = ref(dayjs().endOf('month').format('YYYY-MM-DD'))
</script>

<style scoped lang="less">
.cardBox_ {
  display: flex;
  flex-direction: column;
  padding-top: 19px;
  padding-bottom: 8px;
  //margin: 0 17px;
  height: 80vh;
  .title {
    font-size: 16px;
    font-weight: 500;
    color: rgba(60, 60, 60, 1);
    margin: 0 17px 17px 17px;
  }
  .rules-container {
    font-family: Arial, sans-serif;
    line-height: 1.6;
    overflow: scroll;
    flex: 1;
    padding: 0 17px;
    margin-bottom: 20px;
    h3 {
      font-size: 16px;
      margin-top: 20px;
    }

    p {
      font-size: 14px;
    }

    table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 10px;
      margin-bottom: 6px;
    }

    th,
    td {
      border: 1px solid #ddd;
      text-align: center;
      padding: 8px;
      width: 50%;
      font-size: 15px;
      color: rgba(60, 60, 60, 1);
    }

    th {
      background-color: rgba(234, 234, 234, 1);
      color: rgba(60, 60, 60, 1);
    }
    .examples {
      margin-bottom: 12px;
    }
    .examples ul li {
      list-style: none;
      font-size: 15px;
      color: rgba(102, 102, 102, 1);
    }
    .section {
      color: rgba(102, 102, 102, 1);
      .strong {
        color: rgba(60, 60, 60, 1);
        font-weight: 600;
      }
    }
  }
  .btn {
    //height: 58px;
    width: 100%;
    display: flex;
    padding: 0 17px;
    .btnBox {
      width: 100%;
      background: linear-gradient(
        90deg,
        rgba(250, 81, 15, 1),
        rgba(255, 0, 0, 1) 100%
      ); /* 从左到右的渐变 */
      color: #fff;
      font-size: 16px;
    }
    .btnBoxCancel {
      background: #fff; /* 从左到右的渐变 */
      color: rgba(60, 60, 60, 1);
      font-size: 14px;
      margin-right: 16px;
    }
    border-top-width: 1px;
    border-top-color: rgba(242, 242, 242, 1);
  }
}
</style>
